<template>
  <div class="box">
    <!-- 通栏底部 -->
    <div class="bottom_text">
      <div class="left">杭州境缘文化传播有限公司&nbsp;&nbsp;版权所有</div>
      <div class="right">
        <div>地址：浙江省杭州市余杭区中泰街道跳头55号206室</div>
        <!-- <div>增值电信业务经营许可证：浙B2-20220337</div> -->
        <div>网站备案：浙ICP备2025157073号</div>
      </div>
    </div>
    <div class="line">

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
// @media (min-width: 992px) {

  // 通栏底部
  .box {
    height: 197px;
    background-color: #580f26;
    padding-top: 30px;
    box-sizing: content-box;
    display: flex;
    // justify-content: center;
    flex-direction: column;
    align-items: center;

    .bottom_text {
      width: 714px;
      color: #ffffff;
      display: flex;
      justify-content: space-between;
      padding: 0 54px;
      margin-top: 20px;

      .left {
        font-size: 14px;

      }

      .right {
        font-size: 12px;

        div {
          margin-bottom: 20px;
        }
      }
    }

    .line {
      width: 1200px;
      height: 1px;
      // background-color: #979797;
      background: linear-gradient(225deg, hsla(0, 0%, 100%, 0), #fff 51%, hsla(0, 0%, 100%, 0));
      margin-top: 30px;
    }
  }
// }

@media (max-width: 750px) {}
</style>
